import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { setOnChange } from "components/special";
import { FloatCategories } from "components/special/contents";
import { CompletionsTypesSelector } from "components/standart";

const ContentData = (props) => {
  const { content, setContent } = props;

  const changeContent = setOnChange(content, setContent);

  return (
    <div>
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="OpenAI.Completions.name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="name"
            value={content.name || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
            required
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="OpenAI.Completions.categories" />
        </label>
        <div className="col-8">
          <FloatCategories
            _id={content.categoriesId}
            multi={true}
            showTitle={false}
            showCount={true}
            className="btn-sm"
            successHandler={(categoriesId) => {
              setContent({ ...content, categoriesId });
            }}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="OpenAI.Completions.instructions" />
        </label>
        <div className="col-8">
          <textarea
            name="instructions"
            rows="10"
            value={content.instructions || ""}
            onChange={changeContent}
            className="form-control react-form-input"
            autoComplete="off"
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="OpenAI.Completions.type" />
        </label>
        <div className="col-8">
          <CompletionsTypesSelector
            value={content.type}
            setValue={(type) => setContent({ ...content, ...type })}
            name="type"
          />
        </div>
      </div>
    </div>
  );
};

export default connect(null, {})(ContentData);
